import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';

import FormValue from './FormValue';
import RequestTasksResponse from './RequestTasksResponse';

export function getRequestTasks(
  workspaceId: string,
  bulkRequestId: string,
  {
    count = 100,
    page = 1,
  }: {
    count: number;
    page: number;
  }
): Promise<RequestTasksResponse> {
  return requestApi<RequestTasksResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/request-tasks`),
    method: 'GET',
    credentials: true,
    params: {
      page,
      count,
    },
  }).then((response) => response.data);
}

export interface PutRequestTasksResponse {
  bulkRequestId: string;
}

export function putRequestTasks(
  workspaceId: string,
  bulkRequestId: string,
  {
    formValues,
  }: {
    formValues: FormValue[];
  }
): Promise<PutRequestTasksResponse> {
  return requestApi<PutRequestTasksResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/request-tasks`),
    method: 'PUT',
    credentials: true,
    data: {
      formValues,
    },
  }).then((response) => response.data);
}
